import { Component } from '@angular/core';
import { Ng2StateDeclaration } from '@uirouter/angular';

@Component({
    template: '<ui-view></ui-view>',
    standalone: false
})
export class IndirectContainerComponent {}
export const IndirectRoute: Ng2StateDeclaration = {
    // name: 'indirectrate.**',
    name: 'indirect',
    url: '/indirect',
    redirectTo: 'indirect.rate',
    abstract: true,
    component: IndirectContainerComponent // apparently this is necessary to contain a <ui-view /> :P
    // , loadChildren: () => import('./indirect-rate.module').then(r => r.IndirectRateModule)
};
